module.exports = __webpack_public_path__ + "static/media/lock-grey.76c2a8aa.svg";